import { PlusCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { t } from "i18next";
import { makeAutoObservable } from "mobx";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { makeRolesColumns } from "src/business/role/makeRolesColumns";
import { MdmTable, MdmTableSystemTools } from "src/components/MdmTable";
import { PageLayout } from "src/components/PageLayout";
import { RtSearch } from "src/components/ReactiveTable/components/RtSearch";
import { RtStore } from "src/components/ReactiveTable/RtStore";
import { ToolBox2 } from "src/components/ToolBox2";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";
import { RoleFilters, ZRole } from "src/types/ZRole";

import { loadRoles } from "../../../../business/role/apiRoles";
import { ManagementUsersAndRoles } from "../ManagementUsersAndRoles";

const makeRolesListStore = () =>
  makeAutoObservable({
    tableStore: new RtStore<ZRole, RoleFilters>({
      rowKey: "id",
      loader: loadRoles(),
    }),
  });

export const RolesList: React.FC = observer(() => {
  const [rolesListStore, columns] = useMemo(
    () => [makeRolesListStore(), makeRolesColumns()],
    [],
  );
  const { tableStore } = rolesListStore;

  return (
    <PageLayout title={t("Roles")}>
      <ManagementUsersAndRoles tab="roles">
        <ToolBox2
          paddingMode="page"
          mainTool={<RtSearch store={tableStore} />}
          extraTools={
            <>
              <MdmTableSystemTools store={tableStore} />
              <Link to={makeUrl(PageUrl.managementRoleNew)}>
                <Button type="primary" icon={<PlusCircleOutlined />}>
                  {t("Role")}
                </Button>
              </Link>
            </>
          }
        >
          <MdmTable
            store={tableStore}
            columns={columns}
            resizableColumns
            rowClick={{
              type: "link",
              builder: (row) =>
                makeUrl(PageUrl.managementRoleEdit, { id: row.id }),
            }}
          />
        </ToolBox2>
      </ManagementUsersAndRoles>
    </PageLayout>
  );
});
